import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = 'a2758b906990695174b7dab88fbf8317';

const IS_DEV = import.meta.env.DEV;

export function initMixpanel() {
  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: true,
    persistence: 'localStorage',
    debug: IS_DEV,
  });
  // Tag every event with the environment so local noise can be filtered in Mixpanel
  mixpanel.register({ environment: IS_DEV ? 'local' : 'production' });
}

// ── Typed event names ────────────────────────────────────────────────
export const EVENTS = {
  // Auth & Session
  LOGIN_STARTED: 'Login Started',
  SESSION_RESTORED: 'Session Restored',
  LOGOUT: 'Logout',

  // Event Management
  EVENT_CREATED: 'Event Created',
  EVENT_VIEWED: 'Event Viewed',
  EVENT_UPDATED: 'Event Updated',
  EVENT_ENDED: 'Event Ended',
  EVENT_DELETED: 'Event Deleted',
  EVENTS_LIST_VIEWED: 'Events List Viewed',

  // FTP & Camera
  FTP_ACCOUNT_CREATED: 'FTP Account Created',
  FTP_ACCOUNT_DELETED: 'FTP Account Deleted',
  FTP_PASSWORD_COPIED: 'FTP Password Copied',
  CAMERA_SETUP_GUIDE_OPENED: 'Camera Setup Guide Opened',

  // Gallery
  GALLERY_VIEWED: 'Gallery Viewed',
  GALLERY_FILTERED: 'Gallery Filtered',
  GALLERY_REFRESHED: 'Gallery Refreshed',
  PHOTO_VIEWED: 'Photo Viewed',
  PHOTO_DELETED: 'Photo Deleted',
  PHOTOS_LOAD_MORE: 'Photos Load More',

  // Photo Editor
  EDITOR_OPENED: 'Editor Opened',
  EDITOR_CLOSED: 'Editor Closed',
  EDITOR_STEP_CHANGED: 'Editor Step Changed',
  PRESET_APPLIED: 'Preset Applied',
  PRESET_SKIPPED: 'Preset Skipped',
  FILTER_RESET: 'Filter Reset',
  CROP_TOGGLED: 'Crop Toggled',
  CROP_RATIO_SELECTED: 'Crop Ratio Selected',
  OVERLAY_SELECTED: 'Overlay Selected',
  OVERLAY_REMOVED: 'Overlay Removed',
  EXPORT_PLATFORM_TOGGLED: 'Export Platform Toggled',
  PHOTO_EXPORTED: 'Photo Exported',
  EXPORT_CONFIG_SAVED: 'Export Config Saved',

  // Overlay Management
  OVERLAY_UPLOADED: 'Overlay Uploaded',
  OVERLAY_DELETED: 'Overlay Deleted',

  // Albums — Creator
  ALBUM_CREATED: 'Album Created',
  ALBUM_DELETED: 'Album Deleted',
  ALBUM_TOKEN_REGENERATED: 'Album Token Regenerated',
  ALBUM_PHOTOS_UPDATED: 'Album Photos Updated',
  ALBUM_MEMBER_KICKED: 'Album Member Kicked',
  ALBUM_OVERLAY_CONFIGURED: 'Album Overlay Configured',
  ALBUM_POSTER_DOWNLOADED: 'Album Poster Downloaded',

  // Albums — Member
  ALBUM_PREVIEW_VIEWED: 'Album Preview Viewed',
  ALBUM_JOIN_STARTED: 'Album Join Started',
  ALBUM_JOINED: 'Album Joined',
  ALBUM_JOIN_BLOCKED_DOMAIN: 'Album Join Blocked (Domain)',
  ALBUM_VIEW_OPENED: 'Album View Opened',
  ALBUM_PHOTO_DOWNLOADED: 'Album Photo Downloaded',
  ALBUM_LEFT: 'Album Left',

  // Security
  DEVTOOLS_DETECTED: 'DevTools Detected',

  // Portal / Creator Discovery
  CREATOR_MODE_CLICKED: 'Creator Mode Clicked',
  BECOME_CREATOR_PAGE_VIEWED: 'Become a Creator Page Viewed',
  BECOME_CREATOR_CTA_CLICKED: 'Become a Creator CTA Clicked',
} as const;

// ── Helper ───────────────────────────────────────────────────────────
export function track(event: string, properties?: Record<string, unknown>) {
  mixpanel.track(event, properties);
}

export { mixpanel };
